var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h1',{staticClass:"seo-heading"},[(_vm.heading.prefix)?_c('span',{staticClass:"seo-heading__context"},[_vm._v(_vm._s(_vm.heading.prefix))]):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.heading.name))]),(_vm.heading.suffix)?_c('span',{staticClass:"seo-heading__context"},[_vm._v(_vm._s(_vm.heading.suffix))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }